import { createContext, useEffect } from 'react';

import { createStore } from '../../../utils/store';
import { Source } from '@sodamnfoolish/sjc-backend-types/src/api/feed/dto';

const soundStore = createStore<Record<string, boolean | undefined>>({});

export const SoundStoreContext = createContext(soundStore);

export const SoundStoreProvider = ({ sources, children }: React.PropsWithChildren<{ sources: Source[] }>) => {
    useEffect(() => {
        const savedSoundStatus = localStorage.getItem('soundsEnabled');
        if (savedSoundStatus) {
            soundStore.set(JSON.parse(savedSoundStatus));
            return;
        }

        const defaultState: Record<string, boolean | undefined> = {};
        sources.forEach((source) => {
            defaultState[source.username] = true;
        });

        soundStore.set(defaultState);
    }, [sources]);

    return <SoundStoreContext.Provider value={soundStore}>{children}</SoundStoreContext.Provider>;
};
